import { render, staticRenderFns } from "./VisitorList.vue?vue&type=template&id=b5104e6a&scoped=true&"
import script from "./VisitorList.vue?vue&type=script&lang=js&"
export * from "./VisitorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5104e6a",
  null
  
)

export default component.exports